import React, { useContext } from 'react';
import classes from './Collection.module.scss';
import Card from 'react-bootstrap/Card';
import { Button } from '@/components';
import t from '@/utils/Language/Collection-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { viewportContext } from '@/context/viewport.context';

const CollectionEmptyState = ({ addNewCategory, hasCategories = false, canEdit = false }) => {
  const router = useRouter();
  const { isMobile } = useContext(viewportContext);

  if (hasCategories) {
    return (
      <div className={classes?.collectionEmptyState}>
        <Card>
          <div className={classes.collectionEmptyStateBody}>
            <p className={classes.collectionEmptyStateTitle}>{t('Browse resources in this Collection’s Categories')}</p>
            <div className={classes.collectionEmptyStateContent}>
              <p>{t('Use the Category menu to find organized resources in this Collection.')}</p>
            </div>
          </div>
        </Card>
      </div>
    );
  }

  const getEmptyStateDesc = () => {
    const content = t(
      'Collections are a way to save related items. You can save a resource to a collection by clicking the iconName icon in your search results.'
    );
    const replacedContent = content.replace('${iconName}', '__ICON__');
    const htmlContent = replacedContent.split('__ICON__');

    return (
      <p>
        {htmlContent[0]}
        <FontAwesomeIcon icon={['fas', 'book']} />
        {htmlContent[1]}
      </p>
    );
  };

  return (
    <div className={classes?.collectionEmptyState}>
      <Card>
        <div className={classes.collectionEmptyStateBody}>
          <p className={classes.collectionEmptyStateTitle}>{t('You don’t have anything in this collection yet')}</p>
          <div className={classes.collectionEmptyStateContent}>
            {getEmptyStateDesc()}
            <p>
              {t('Collection resources can be organized into categories. Start adding to this collection by using one of the suggestions below.')}
            </p>
          </div>
          <div className={classes.collectionEmptyStateButtons}>
            {canEdit && (
              <Button
                dataCy="button-add-client"
                type="primary"
                icon={{ style: 'fas', font: 'plus' }}
                text={t('Add new category')}
                styles={{ width: isMobile ? 'full' : 'half' }}
                onButtonClick={(e) => addNewCategory(e)}
              />
            )}

            <Button
              dataCy="button-add-client"
              type="primary"
              icon={{ style: 'fas', font: 'search' }}
              text={t('Search for resources')}
              styles={{ width: isMobile ? 'full' : 'half' }}
              onButtonClick={() => router.push('/browse')}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CollectionEmptyState;
